/**
 * Given a sample rate, returns true if replay should be sampled.
 *
 * 1.0 = 100% sampling
 * 0.0 = 0% sampling
 */
function isSampled(sampleRate) {
  if (sampleRate === undefined) {
    return false;
  } // Math.random() returns a number in range of 0 to 1 (inclusive of 0, but not 1)


  return Math.random() < sampleRate;
}

export { isSampled };